import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { LoadingService } from 'app/shared/services/loading.service';
import { LetterOfCreditService } from 'app/credit/services/letter-of-credit.service';
import { StaffRoleService, GeneralSetupService, CurrencyService } from 'app/setup/services';
import { CreditAppraisalService } from 'app/credit/services';
import { GlobalConfig, ApprovalStatus } from 'app/shared/constant/app.constant';
import { DatePipe } from '@angular/common';
import { CasaService } from 'app/customer/services/casa.service';
import { List } from 'lodash';
import { ExchangeRateService } from 'app/admin/services';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'lc-issuance',
  templateUrl: './lc-issuance.component.html',
})

export class LcIssuanceComponent implements OnInit {

  // ------------------- declarations -----------------

    @Input() panel: boolean = false;
    @Input() label: string = '';
    // reload: number = 0;
    @Input() isForReleaseOfShippingDocuments = false;
    @Input() isForLCUssance = false;
    @Input() isLCSearch = false;
    @Input() OPERATION_ID = 135;
    @Input() lcIssuanceId = 0;
    @Input() showButtons = true;
    @Input() releaseAmount = 0;
    @Input() lcReleaseAmountId = 0;
    @Input() lcUssanceId = 0;
    @Input() totalUsanceAmount: 0;

    LCAmountCurrencyCode: string;
    targetId = 0;

    @Input() set reload(value: number) { if (value > 0) this.getLcIssuances(); }
    @Input() set resetTabs(value: number) {
        if (value > 0) {
            this.customerId = null;
            this.selectedId = null;
            this.resetActiveTabIndex();
            this.initializeControls();
        }
        
    }

    formState: string = 'New';
    selectedId: number = null;
    activeTabindex: number = 0;
    IsOnLcIssuanceListTab: boolean;
    lcForwardTitle = 'LC Issuance';
    forwardAction: number;
    lcSelection: any;
    lcIssuances: any[] = [];
    lcUssance: any;
    customerAccount: any[];
    lines: any[];
    selectedApplicationId: number;
    lcIssuanceForm: FormGroup;
    lcUssanceForm: FormGroup;
    lcForwardForm: FormGroup;
    displayLcIssuanceForm: boolean = false;
    customer: any;
    customerName: string;
    customerId: number;
    lcReferenceNumber: number;
    showSearchCustomerDialog = false;
    staffRoleRecord: any;
    proposedItems: any;
    addCashBuildUpDetails = false;

    currentStaffActivities: string[];
    // isAccountOfficer = false;
    approvalStatusData: any[];
    showLcForward = false;
    vote: number;
    OPERATION_IDs: number[];
    privilege: any = {
        viewCamDocument: false,
        viewUploadedFiles: false,
        viewApproval: false,
        canMakeChanges: false,
        canApprove: false,
        canUploadFile: false,
        canSendRequest: false,
        canEscalate: false,
        canAppendTemplate: true,
        owner: false,
        approvalLimit: 0,
        userApprovalLevelIds: null,
        currentApprovalLevelId: 0,
        currentApprovalLevel: null,
        staffId: null,
        roleId: null,
        userBranchId: null,
        // investmentGradeApprovalLimit: 10000, // todo later
        // maximumTenor: 223, // todo later
        groupRoleId: 1, // bu,ca,md,comm,bd
    };
    currencies: any[];
    lcType = [
        {name: 'Confirmed', id: 1},
        {name: 'Unconfirmed', id: 2}
    ];

    lcFundSource = [
        {name: 'Cash', id: 1},
        {name: 'IFF Line', id: 2}
    ];
    outstandingUsanceAmount: number;
    allExchangeRates: any[];
    nairaEquivalent: number;
    nairaEquivalent2: number;
    lcAmtExchangeRate: number;
    numberOfLCRequiredDocuments = 0;
    numberOfShippingDocuments = 0;
    numberOfLCConditions = 0;
    numberOfShippings = 0;
    

    // ---------------------- init ----------------------

    constructor(
        private fb: FormBuilder,
        private loadingService: LoadingService,
        private staffRole: StaffRoleService,
        private lcService: LetterOfCreditService,
        private genSetupService: GeneralSetupService,
        private camService: CreditAppraisalService,
        private currencyService: CurrencyService,
        private casaService: CasaService,
        private exchangeServ: ExchangeRateService,
    ) { }

	ngOnInit() {
        this.setOperationId();
        this.getCurrentStaffActivities();
		this.initializeControls();
        this.getAllApprovalStatus();
        this.getAllCurrencies();
        this.getLcIssuances(); 1784336657
        this.getAllExchangeRates();
    }

    setOperationId() {
        if (this.isForRelease()) {
            this.OPERATION_IDs = [135,138]
            this.OPERATION_ID = 138;
        } else if (this.isForUssance()) {
            this.OPERATION_IDs = [135,138,140];
            this.OPERATION_ID = 140;
        } else if (!this.isForRelease() && !this.isForUssance()) {
            this.OPERATION_IDs = [135];
            this.OPERATION_ID = 135;
        }
    }
    
    initializeControls() {
        this.resetActiveTabIndex();
        this.clearControls();
        this.initializeLCUssance();
        this.lcForwardForm = this.fb.group({
            forward: [''],
            comment: ['', Validators.required]
        });

     
    }

    getApprovalStatus(approvalStatus) {
            let processLabel = 'PROCESSING';
            // if (this.privilege.groupRoleId != ApprovalGroupRole.BU) { processLabel = 'FAM PROCESS'; }
            if (approvalStatus == ApprovalStatus.PROCESSING)
                return '<span class="label label-info">' + processLabel + '</span>';
            if (approvalStatus == ApprovalStatus.AUTHORISED)
                return '<span class="label label-info">' + processLabel + '</span>';
            if (approvalStatus == ApprovalStatus.REFERRED)
                return '<span class="label label-danger">REFERRED BACK</span>';
            if (approvalStatus == ApprovalStatus.APPROVED)
                return '<span class="label label-success">APPROVED</span>';
            if (approvalStatus == ApprovalStatus.DISAPPROVED)
                return '<span class="label label-danger">REJECTED</span>';
        return '<span class="label label-warning">NEW APPLICATION</span>';
    }

    getAllApprovalStatus(): void {
        this.genSetupService.getApprovalStatus().subscribe((response: any) => {
            const tempData = response.result;
            this.approvalStatusData = tempData.slice(2, 4);
        });
    }

    getAllCurrencies() {
        this.currencyService.getAllCurrencies().subscribe((res: any) => {
            this.currencies = res.result;
            // console.log("currencies", this.currencies);
        }, (err) => {
            ////console.log(err);
        });
    }

    getAllCustomerAccount(customerId: number) {
        this.casaService.getAllCustomerAccountByCustomerId(customerId)
        .subscribe((response: any) => {
            this.customerAccount = response.result;
        });
    }

    canEdit(): boolean { 
        return  this.privilege.canAppendTemplate;
    }

    canUpload(): boolean {
        return this.privilege.canUploadFile;
    }

    // extraInits() {
    //     this.lcSelection.currentApprovalLevelId = 0;// refer back
    //     this.lcSelection.toStaffId = 0;
    // }
    
    getIFFLinesForLc(customerId: number) {
        this.lcService.getIFFLinesForLc(customerId).subscribe
        ((response) => {
            this.lines = response.result;
           // console.log(this.lines);
        });
    }

    isForRelease(): boolean {
        return this.isForReleaseOfShippingDocuments;
    }

    isForUssance(): boolean {
        return this.isForLCUssance;
    }

    isForLCSearch(): boolean {
        return this.isLCSearch;
    }
    
    isForReleaseOrUssanceOrSearch(): boolean {
        // console.log(this.isForReleaseOfShippingDocuments || this.isForLCUssance);
        return (this.isForReleaseOfShippingDocuments || this.isForLCUssance || this.isLCSearch);
    }
    // isAnAccountOfficer():boolean {
    //     return this.isAccountOfficer;
    // }

    isOnIssuanceListTab(): boolean {
        return this.activeTabindex == 0;
    }

    

    isAmongActivities(activity: string): boolean {
        activity = activity.toLowerCase();
        if (this.currentStaffActivities == undefined) {
            return false;
        }
        return (this.currentStaffActivities.indexOf(activity) >= 0);
    }

    onTabChange(event) {
        this.activeTabindex = event.index;
    }

    showCustomerSearchForm() {
        this.showSearchCustomerDialog = true;
    }

	onlcIssuanceChange(event) {
        //console.log(this.lcSelection);
        
        this.addCashBuildUpDetails = event.data.cashBuildUpAvailable;
        this.setExchangeRate(event.data.currencyId);
        this.selectedId = event.data.lcIssuanceId;
        this.targetId = this.selectedId;
        if (this.isForUssance()) {
            this.totalUsanceAmount = this.lcSelection.totalUsanceAmount;
            this.outstandingUsanceAmount = this.lcSelection.totalUsanceAmount;
            this.getLcUssance(event.data.lcUssanceId);
            this.lcUssanceId = event.data.lcUssanceId;
            this.targetId = this.lcUssanceId;
        }
        if(this.isForLCSearch()) {
            this.outstandingUsanceAmount = this.totalUsanceAmount;
            this.getLcUssance(this.lcUssanceId);
            this.LCAmountCurrencyCode = this.getCurrencyCode(event.data.currencyId);
        }
        this.getAllCustomerAccount(event.data.customerId);
        this.getIFFLinesForLc(event.data.customerId);
        this.lcReferenceNumber = event.data.lcReferenceNumber;
        this.customerId = event.data.customerId;
        this.reload = event.data.lcIssuanceId;
        // this.activeTabindex = 0;
        this.activeTabindex = 1;
        if (this.isForRelease()) {
            this.getUserPrivileges(this.lcSelection.currentApprovalLevelId);
            this.lcReleaseAmountId = event.data.lcReleaseAmountId;
            this.releaseAmount = event.data.releaseAmount;
            this.LCAmountCurrencyCode = this.getCurrencyCode(event.data.currencyId);
            this.targetId = this.lcReleaseAmountId;
        }
        this.editLcIssuance(this.lcSelection);
        if (event.data.fundSourceId == 2) {
            this.selectedApplicationId = this.lcIssuanceForm.controls['fundSourceDetails'].value;
            this.getLoanDetails(this.selectedApplicationId);
        }
    }
    
    setCustomerName(event) {
        this.customerName = event.customerName;
    }

    resetActiveTabIndex() {
        this.activeTabindex = 0;
        this.activeTabindex = 0;
        this.activeTabindex = 0;
    }

    setCustomer(event) {
        this.customerId = event.customerId;
        this.getAllCustomerAccount(event.customerId);
        this.getIFFLinesForLc(event.customerId);
        this.initializeControls();
        this.lcIssuanceForm.controls['customerId'].setValue(event.customerId);
        this.activeTabindex = 1;
        this.selectedId = null;
        this.reload = event.customerId;
        this.showSearchCustomerDialog = false;
    }

    // setCashBuildUpDetails(event){
    //     this.addCashBuildUpDetails = event.target.checked;
    //     if (!(this.addCashBuildUpDetails)) {
    //     this.lcIssuanceForm.controls['cashBuildUpReferenceType'].reset;
    //     this.lcIssuanceForm.controls['cashBuildUpReferenceNumber'].reset;
    //     this.lcIssuanceForm.controls['percentageToCover'].reset;
    //     }
    // }

    isCashBuildUpAvailable(): boolean {
        return this.addCashBuildUpDetails;
    }

    // getUserRole() {
    //     this.staffRole.getStaffRoleByStaffId().subscribe((res: any)=>{
    //         this.staffRoleRecord = res.result;
    //         console.log(this.staffRoleRecord);
    //         if (this.staffRoleRecord.staffRoleCode == 'AO') {
    //             this.isAccountOfficer = true;
    //         } else {
    //             this.isAccountOfficer = false
    //         }
    //     this.getLcIssuances();
    //     });
    // }

    getCurrentStaffActivities() {
        this.lcService.getCurrentStaffActivities().subscribe(
            (res) => {
            this.currentStaffActivities = res.result;
            // console.log(this.currentStaffActivities);
        });
    }

    resetButton(value) {
        //console.log('On approval status change ' + value);
    }

    getCurrencyCode(value): string {
        if ((value == undefined) || (value == null)) {
          //  console.log('value =>' + value);
            return '';
        }
        if ((this.currencies == undefined) || (this.currencies == null)) {return;}
        let currency = this.currencies.find(c => c.currencyId == value);
        return currency.currencyCode;
    }

    resetAmounts() {
        this.lcIssuanceForm.controls['availableAmountCurrencyCode'].setValue("");
        this.lcIssuanceForm.controls['totalApprovedAmountCurrencyCode'].setValue("");
        this.lcIssuanceForm.controls['availableAmountCurrencyId'].setValue("");
        this.lcIssuanceForm.controls['totalApprovedAmountCurrencyId'].setValue("");
        this.lcIssuanceForm.controls['availableAmount'].setValue("");
        this.lcIssuanceForm.controls['totalApprovedAmount'].setValue("");
    }

    setAmounts(value) {
        this.resetAmounts();
        // console.log(this.customerAccount.find(a => a.casaAccountId == value).availableBalance);
        let bal = this.customerAccount.find(a => a.casaAccountId == value);
       // console.log(bal);
        this.lcIssuanceForm.controls['availableAmountCurrencyCode'].setValue(this.getCurrencyCode(bal.currencyId));
        this.lcIssuanceForm.controls['totalApprovedAmountCurrencyCode'].setValue(this.getCurrencyCode(bal.currencyId));
        this.lcIssuanceForm.controls['availableAmountCurrencyId'].setValue(bal.currencyId);
        this.lcIssuanceForm.controls['totalApprovedAmountCurrencyId'].setValue(bal.currencyId);
        this.lcIssuanceForm.controls['availableAmount'].setValue(bal.availableBalance);
        this.lcIssuanceForm.controls['totalApprovedAmount'].setValue(bal.availableBalance);
        }

    setIFFAmounts(applicationId) {
        this.resetAmounts();
        this.getLoanDetails(applicationId);
        let line = this.lines.find(l => l.loanApplicationId == applicationId);
       // console.log(line);
        // console.log(this.customerAccount.find(a => a.casaAccountId == value).availableBalance);
        this.lcIssuanceForm.controls['availableAmountCurrencyCode'].setValue(this.getCurrencyCode(line.currencyId));
        this.lcIssuanceForm.controls['totalApprovedAmountCurrencyCode'].setValue(this.getCurrencyCode(line.currencyId));
        this.lcIssuanceForm.controls['availableAmountCurrencyId'].setValue(line.currencyId);
        this.lcIssuanceForm.controls['totalApprovedAmountCurrencyId'].setValue(line.currencyId);
        this.lcIssuanceForm.controls['availableAmount'].setValue(line.customerAvailableAmount);
        this.lcIssuanceForm.controls['totalApprovedAmount'].setValue(line.approvedAmount);
    }

    getLoanDetails(applicationId): void {
        this.loadingService.show();
        this.camService.getLoanDetail(applicationId).subscribe((response: any) => {
           // console.log(response.result.facilities);
            this.proposedItems = response.result.facilities;
            this.loadingService.hide();
            this.selectedApplicationId = applicationId;
        }, (err) => {
            this.loadingService.hide(1000);
        });
    }

    resetLCFundSource(value) {
      //  console.log('On fund source change ' + value);
        this.selectedApplicationId = null;
        this.lcIssuanceForm.controls['fundSourceDetails'].setValue("");
        this.resetAmounts();
    }

    lcFundSourceId(): number {
        return this.lcIssuanceForm.controls['fundSourceId'].value;
    }

    closeDialog() {
        this.showLcForward = false;
    }

    forward() {
        this.showLcForward = true;
    }

    getUserPrivileges(levelId = null) {
        let body = {
            levelId: levelId,
            operationId: this.OPERATION_ID,
        }
        this.camService.getPrivilege(body).subscribe((response: any) => {
            this.privilege = response.result;
            // this.privilege.currentApprovalLevelId = this.obligor.currentApprovalLevelId;
            // this.privilege.currentApprovalLevel = this.loanSelection.currentApprovalLevel;
           
        });
    }

    fillUsanceMaturityDate(event) {
       // console.log(event.target.value);
        let time = new Date(this.lcUssanceForm.controls['lcEffectiveDate'].value).getTime();
       // console.log(time);
        let newTime = time + (event.target.value * 86400 * 1000);
       // console.log(new Date(newTime));
        this.lcUssanceForm.controls['lcMaturityDate'].setValue(new Date(newTime));

    }

    getExhangeRate(currencyId): number {
        if (currencyId != null)
        {return this.allExchangeRates.find(r => r.currencyId == currencyId).exchangeRate;}
    }

    setExchangeRate(currencyId) {
        if (this.allExchangeRates.length > 0)
        {
            this.lcIssuanceForm.controls['letterOfCreditAmount'].updateValueAndValidity();
            this.lcAmtExchangeRate = this.getExhangeRate(currencyId);
            this.lcIssuanceForm.controls['lcAmtExchangeRate'].setValue(this.lcAmtExchangeRate);
           // console.log('this.lcIssuanceForm.controls[\'letterOfCreditAmount\'].value', this.lcIssuanceForm.controls['letterOfCreditAmount'].value);
            let lcAmt = this.lcIssuanceForm.get('letterOfCreditAmount').value;
            this.nairaEquivalent = this.lcAmtExchangeRate * parseFloat(String(lcAmt).replace(/,/g,''));
            this.lcIssuanceForm.controls['nairaEquivalent'].setValue(this.nairaEquivalent);
            this.calculateToleranceAmount();
        }
    }       
  // ------------------- api-calls --------------------

    goForApproval() {
        const __this = this;
            swal({
                title: 'Are you sure?',
                text: 'You want to submit?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No, cancel!',
                confirmButtonClass: 'btn btn-success btn-move',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: true,
            }).then(function () {
                __this.loadingService.show();
            // if (__this.lcForwardForm.controls['forward'].value == 2) {
            //     if (__this.privilege.canApprove == true) {
            //         __this.vote = __this.lcForwardForm.controls['forward'].value;
            //         __this.forwardAction = __this.lcForwardForm.controls['forward'].value;
            //     } else {
            //         __this.vote = __this.lcForwardForm.controls['forward'].value;
            //         __this.forwardAction = 0;
            //     }
            // } else {
            //     __this.vote = __this.lcForwardForm.controls['forward'].value;
            //     __this.forwardAction = __this.lcForwardForm.controls['forward'].value;
            // }
            __this.vote = 1;
            __this.forwardAction = 0;
                
            let body = {
                    forwardAction: __this.forwardAction,
                    comment: __this.lcForwardForm.controls['comment'].value,
                    lcIssuanceId: __this.selectedId,
                    lcUssanceId: __this.lcUssanceId,
                    amount: __this.lcIssuanceForm.controls['totalApprovedAmount'].value,
                    lcReleaseAmountId: __this.lcReleaseAmountId,
                    releaseAmount: __this.releaseAmount,
                    // d,receiverLevelId: this.lcSelection.currentApprovalLevelId, // refer back
                    // receiverStaffId: this.lcSelection.toStaffI // refer back
                    vote: __this.vote,
                    // isBusiness: this.isBusiness,
                };

            if (__this.isForRelease()) {
                __this.lcService.forwardLcRelease(body)
                        .subscribe((res: any) => {
                            __this.loadingService.hide();
                            if (res.success === true) {
                                __this.customerId = null;
                                __this.selectedId = null;
                                __this.reload = 1;
                                __this.getLcIssuances();
                                __this.initializeControls();
                                __this.showLcForward = false;
                                    swal(`${GlobalConfig.APPLICATION_NAME}`, 
                                    '<br/> ' + res.message , 'success');
                            } else {
                                __this.showLcForward = false;
                                swal(`${GlobalConfig.APPLICATION_NAME}`, res.message, 'error');
                                __this.loadingService.hide();
                            }
                        }, (err) => {
                            __this.showLcForward = false;
                            __this.loadingService.hide();
                            swal(`${GlobalConfig.APPLICATION_NAME}`, JSON.stringify(err), 'error');
                        });
            } else if (__this.isForUssance()) {
                __this.lcService.forwardLcUssance(body)
                    .subscribe((res: any) => {
                        __this.loadingService.hide();
                        if (res.success === true) {
                            __this.customerId = null;
                            __this.selectedId = null;
                            __this.reload = 1;
                            __this.getLcIssuances();
                            __this.initializeControls();
                            __this.showLcForward = false;
                                swal(`${GlobalConfig.APPLICATION_NAME}`, 
                                '<br/> ' + res.message , 'success');
                        } else {
                            __this.showLcForward = false;
                            swal(`${GlobalConfig.APPLICATION_NAME}`, res.message, 'error');
                            __this.loadingService.hide();
                        }
                    }, (err) => {
                        __this.showLcForward = false;
                        __this.loadingService.hide();
                        swal(`${GlobalConfig.APPLICATION_NAME}`, JSON.stringify(err), 'error');
                    })
            } else if (!(__this.isForRelease() && __this.isForUssance())) {
                __this.lcService.forwardLcIssuance(body)
                    .subscribe((res: any) => {
                        __this.loadingService.hide();
                        if (res.success === true) {
                            __this.customerId = null;
                            __this.selectedId = null;
                            __this.reload = 1;
                            __this.getLcIssuances();
                            __this.initializeControls();
                            __this.showLcForward = false;
                                swal(`${GlobalConfig.APPLICATION_NAME}`, 
                                '<br/> ' + res.message , 'success');
                        } else {
                            __this.showLcForward = false;
                            swal(`${GlobalConfig.APPLICATION_NAME}`, res.message, 'error');
                            __this.loadingService.hide();
                        }
                    }, (err: any) => {
                        __this.showLcForward = false;
                        __this.loadingService.hide();
                        swal(`${GlobalConfig.APPLICATION_NAME}`, JSON.stringify(err), 'error');
                    })
                }
            }, function (dismiss) {
                if (dismiss === 'cancel') {
                    swal(`${GlobalConfig.APPLICATION_NAME}`, 'Operation cancelled', 'error');
                }
            });
    }

    saveLcIssuance(form) {
        let body = {
            beneficiaryName: form.value.beneficiaryName,
            totalApprovedAmount: form.value.totalApprovedAmount,
            totalApprovedAmountCurrencyId: form.value.totalApprovedAmountCurrencyId,
            availableAmountCurrencyId: form.value.availableAmountCurrencyId,
            cashBuildUpAvailable: form.value.cashBuildUpAvailable,
            cashBuildUpReferenceType: form.value.cashBuildUpReferenceType,
            cashBuildUpReferenceNumber: form.value.cashBuildUpReferenceNumber,
            percentageToCover: form.value.percentageToCover,
            lcTolerancePercentage: form.value.lcTolerancePercentage,
            lcToleranceValue: form.value.lcToleranceValue,
            releaseAmount: form.value.releaseAmount,
            letterOfCreditTypeId: form.value.letterOfCreditTypeId,
            isDraftRequired: form.value.isDraftRequired,
            beneficiaryAddress: form.value.beneficiaryAddress,
            beneficiaryEmail: form.value.beneficiaryEmail,
            customerId: form.value.customerId,
            fundSourceId: form.value.fundSourceId,
            fundSourceDetails: form.value.fundSourceDetails,
            formMNumber: form.value.formMNumber,
            beneficiaryPhoneNumber: form.value.beneficiaryPhoneNumber,
            beneficiaryBank: form.value.beneficiaryBank,
            currencyId: form.value.currencyId,
            proformaInvoiceId: form.value.proformaInvoiceId,
            availableAmount: form.value.availableAmount,
            letterOfCreditAmount: form.value.letterOfCreditAmount,
            letterOfcreditExpirydate: form.value.letterOfcreditExpirydate,
            invoiceDate: form.value.invoiceDate,
            invoiceDueDate: form.value.invoiceDueDate,
            lcReferenceNumber: form.value.lcReferenceNumber,
        };
        this.loadingService.show();
        if (this.selectedId == null) {
            this.lcService.saveLcIssuance(body).subscribe((response: any) => {
                this.loadingService.hide();
                if (response.success == true) {
                    swal(`${GlobalConfig.APPLICATION_NAME}`, 
                    '<br/> The record was created successfully with Reference Number <b>' 
                    + response.result.lcReferenceNumber + '</b>', 'success');
                    this.reloadGrid();
                    this.editLcIssuance(response.result);
                    this.selectedId = response.result.lcIssuanceId;
                }
                else this.finishBad(response.message);
            }, (err: any) => {
                this.loadingService.hide();
                this.finishBad(JSON.stringify(err));
            });
        } else {
            this.lcService.updateLcIssuance(body, this.selectedId).subscribe((response: any) => {
                this.loadingService.hide();
                if (response.success == true) {
                    this.finishGood(response.message);
                this.reloadGrid();
                }
                else this.finishBad(response.message);
            }, (err: any) => {
                this.loadingService.hide();
                this.finishBad(JSON.stringify(err));
            });
        }
    }

    getLcIssuances() {
            this.lcIssuances = [];
            if (this.isForRelease()) {
                    this.lcService.getLcIssuancesForRelease().subscribe((response: any) => {
                        this.lcIssuances = response.result;
                    });
            } else if (this.isForUssance()) {
                this.lcService.getLcIssuancesForUssance().subscribe((response: any) => {
                    this.lcIssuances = response.result;
                });
            } else if (this.isForLCSearch()) {
                this.lcService.getLcIssuancesByLcIssuanceId(this.lcIssuanceId).subscribe((response: any) => {
                    this.lcIssuances = response.result;
                  //  console.log('this.lcIssuances', this.lcIssuances);
                });
                this.getLcUssance(this.lcUssanceId);
            } else if ((!this.isForRelease()) && (!this.isForUssance()) && (!this.isForLCSearch())) {
                this.lcService.getLcIssuances().subscribe((response: any) => {
                    this.lcIssuances = response.result;
                });
            } 
    }

    deleteLcIssuance(row) {
        this.lcService.deleteLcIssuance(row.lcIssuanceId).subscribe((response: any) => {
            if (response.result == true) this.reloadGrid();
        });
    }

    reloadGrid() {
        this.displayLcIssuanceForm = false;
        this.getLcIssuances();
    }

    getAllExchangeRates() {
        this.exchangeServ.get().subscribe((res: any) => {
            this.allExchangeRates = res.result;
           // console.log('this.allExchangeRates', this.allExchangeRates);
        }, (err: HttpErrorResponse) => {
            this.showMessage(err.message, 'error', 'FintrakBanking');
        });
    }

  // ---------------------- form ----------------------

  clearControls() {
    this.selectedApplicationId = null;
    this.formState = 'New';
      this.lcIssuanceForm = this.fb.group({
            beneficiaryName: ['', Validators.required],
            totalApprovedAmount: ['', Validators.required],
            totalApprovedAmountCurrencyId: [''],
            availableAmountCurrencyId: [''],
            availableAmountCurrencyCode: [''],
            totalApprovedAmountCurrencyCode: [''],
            lcAmtExchangeRate: [''],
            nairaEquivalent: [''],
            nairaEquivalent2: [''],
            cashBuildUpAvailable: [false],
            cashBuildUpReferenceType: [''],
            cashBuildUpReferenceNumber: [''],
            percentageToCover: [''],
            lcTolerancePercentage: [''],
            lcToleranceValue: [''],
            releaseAmount: [''],
            letterOfCreditTypeId: ['', Validators.required],
            isDraftRequired: [''],
            beneficiaryAddress: ['', Validators.required],
            beneficiaryEmail: ['', [Validators.required, Validators.email]],
            customerId: ['', Validators.required],
            fundSourceId: ['', Validators.required],
            fundSourceDetails: ['', Validators.required],
            formMNumber: ['', Validators.required],
            beneficiaryPhoneNumber: ['', Validators.required],
            beneficiaryBank: ['', Validators.required],
            currencyId: ['', Validators.required],
            proformaInvoiceId: ['', Validators.required],
            availableAmount: ['', Validators.required],
            letterOfCreditAmount: ['', Validators.required],
            letterOfcreditExpirydate: ['', Validators.required],
            invoiceDate: ['', Validators.required],
            invoiceDueDate: ['', Validators.required],
            lcReferenceNumber: [''],
      });
  }

  

    editLcIssuance(row) {
        this.clearControls();
        this.formState = 'Edit';
        this.selectedId = row.lcIssuanceId;
        this.lcIssuanceForm.setValue({
            beneficiaryName: row.beneficiaryName,
            totalApprovedAmount: row.totalApprovedAmount,
            totalApprovedAmountCurrencyId: row.totalApprovedAmountCurrencyId,
            availableAmountCurrencyId: row.availableAmountCurrencyId,
            availableAmountCurrencyCode: this.getCurrencyCode(row.availableAmountCurrencyId),
            totalApprovedAmountCurrencyCode: this.getCurrencyCode(row.totalApprovedAmountCurrencyId),
            lcAmtExchangeRate: this.getExhangeRate(row.currencyId),
            nairaEquivalent: this.getExhangeRate(row.currencyId) * row.letterOfCreditAmount,
            nairaEquivalent2: this.getExhangeRate(row.currencyId) * row.lcToleranceValue,
            cashBuildUpAvailable: row.cashBuildUpAvailable,
            cashBuildUpReferenceType: row.cashBuildUpReferenceType,
            cashBuildUpReferenceNumber: row.cashBuildUpReferenceNumber,
            percentageToCover: row.percentageToCover,
            lcTolerancePercentage: row.lcTolerancePercentage,
            lcToleranceValue: row.lcToleranceValue,
            releaseAmount: row.releaseAmount,
            letterOfCreditTypeId: row.letterOfCreditTypeId,
            isDraftRequired: row.isDraftRequired,
            beneficiaryAddress: row.beneficiaryAddress,
            beneficiaryEmail: row.beneficiaryEmail,
            customerId: row.customerId,
            fundSourceId: row.fundSourceId,
            fundSourceDetails: row.fundSourceDetails,
            formMNumber: row.formMNumber,
            beneficiaryPhoneNumber: row.beneficiaryPhoneNumber,
            beneficiaryBank: row.beneficiaryBank,
            currencyId: row.currencyId,
            proformaInvoiceId: row.proformaInvoiceId,
            availableAmount: row.availableAmount,
            letterOfCreditAmount: row.letterOfCreditAmount,
            letterOfcreditExpirydate: new Date(row.letterOfcreditExpirydate),
            invoiceDate: new Date(row.invoiceDate),
            invoiceDueDate: new Date(row.invoiceDueDate),
            lcReferenceNumber: row.lcReferenceNumber,
        });
        //   this.displayLcIssuanceForm = true;
    }

    showLcIssuanceForm() {
        this.clearControls();
        this.selectedId = null;
        this.displayLcIssuanceForm = true;
    }

    initializeLCUssance() {
        if (this.isForUssance() || this.isForLCSearch()) {
            this.resetUssanceForm();
        }
    }

    resetUssanceForm() {
        this.lcUssanceForm = this.fb.group({
            lcIssuanceId: [''],
            lcUssanceId: [''],
            ussanceAmount: ['', Validators.required],
            usanceAmountCurrencyId: ['', Validators.required],
            ussanceRate: ['', Validators.required],
            ussanceTenor: ['', Validators.required],
            lcEffectiveDate: ['', Validators.required],
            lcMaturityDate: ['', Validators.required],
        });
    }

    saveUssanceForm(form) {
        form.value.lcIssuanceId = this.selectedId;
        //console.log(form.value);
    if (!(form.value.lcUssanceId>0)) {
      //  console.log(form.value);
        this.lcService.saveLcUssance(form.value).subscribe((response: any) => {
            this.loadingService.hide();
            if (response.success == true) {
                swal(`${GlobalConfig.APPLICATION_NAME}`, 
                '<br/> The LC Usance record was added successfully<b>' , 'success');
                this.resetUssanceForm();
                this.getLcUssance(response.result.lcUssanceId);
            }
            else this.finishBad(response.message);
        }, (err: any) => {
            this.loadingService.hide();
            this.finishBad(JSON.stringify(err));
        });
    } else {
        this.lcService.updateLcUssance(form.value, form.value.lcUssanceId).subscribe((response: any) => {
            this.loadingService.hide();
            if (response.success == true) {
                this.finishGood(response.message);
            this.reloadGrid();
            }
            else this.finishBad(response.message);
        }, (err: any) => {
            this.loadingService.hide();
            this.finishBad(JSON.stringify(err));
        });
    }
    }

    // getLcUssances(lcIssuanceId) {
    //     if (lcIssuanceId == null || lcIssuanceId == undefined) return;
    //     this.lcService.getLcUssanceByLcIssuanceId(lcIssuanceId).subscribe
    //     ((response) => {
    //         this.lcUssance = response.result;
    //         if (this.lcUssance != null) {
    //             this.editUssanceForm(response.result);
    //         }
    //     });
    // }

    getLcUssance(lcUsuanceId) {
        if (lcUsuanceId == null || lcUsuanceId == undefined) return;
        this.lcUssanceId = lcUsuanceId;
        this.lcService.getLcUssanceByLcUsanceId(lcUsuanceId).subscribe
        ((response) => {
            this.lcUssance = response.result;
            if (this.lcUssance != null) {
                this.editUssanceForm(response.result);
            }
        if (response.result.ussanceAmount > 0) {
            this.outstandingUsanceAmount = this.totalUsanceAmount - +response.result.ussanceAmount;
        }
        console.log(response.result);
        console.log('totalUsanceAmount', this.totalUsanceAmount);
        // console.log('lcSelection', this.lcSelection);
        });
    }

    editUssanceForm(row) {
        this.lcUssanceForm.setValue({
            lcIssuanceId: [''],
            lcUssanceId: row.lcUssanceId,
            ussanceAmount: row.ussanceAmount,
            usanceAmountCurrencyId: row.usanceAmountCurrencyId,
            ussanceRate: row.ussanceRate,
            ussanceTenor: row.ussanceTenor,
            lcEffectiveDate: new Date(row.lcEffectiveDate),
            lcMaturityDate: new Date(row.lcMaturityDate)
        });
    }
    
    calculateToleranceAmount(event = null) {
        let lcAmt = this.lcIssuanceForm.get('letterOfCreditAmount').value;
        lcAmt = parseInt(String(lcAmt).replace(/,/g,''));
        let percentage: number;
        if (event == null) {
            percentage = this.lcIssuanceForm.get('lcTolerancePercentage').value;
        } else {
            percentage = +event.target.value;
            console.log(percentage);
        }
        let toleranceAmt = this.getPercentage(percentage, lcAmt) + lcAmt;
        console.log(toleranceAmt);
        this.lcIssuanceForm.controls['lcToleranceValue'].setValue(toleranceAmt);
        this.lcAmtExchangeRate = this.lcIssuanceForm.controls['lcAmtExchangeRate'].value;
        this.nairaEquivalent2 = this.lcAmtExchangeRate * parseFloat(String(toleranceAmt).replace(/,/g,''));
        this.lcIssuanceForm.controls['nairaEquivalent2'].setValue(this.nairaEquivalent2);
    }

    getPercentage(percent: number, target: number): number {
        let percentageAmt = ((percent/100) * target);
        console.log(percentageAmt);
        return percentageAmt;
    }

    setExchangeAmt(event) {
        let lcAmt = this.lcIssuanceForm.get('letterOfCreditAmount').value;
        lcAmt = parseFloat(String(lcAmt).replace(/,/g,''));
        this.lcAmtExchangeRate = this.lcIssuanceForm.controls['lcAmtExchangeRate'].value;
        this.nairaEquivalent = this.lcAmtExchangeRate * parseFloat(String(lcAmt).replace(/,/g,''));
        this.lcIssuanceForm.controls['nairaEquivalent'].setValue(this.nairaEquivalent);
        this.calculateToleranceAmount();
    }

    saveRelease() {
        let body = {
            lcReleaseAmountId: this.lcReleaseAmountId,
            lcIssuanceId:this.selectedId,
            releaseAmount: this.releaseAmount,
        };
        this.loadingService.show();
        if (!(this.lcReleaseAmountId > 0)) {
            this.lcService.saveReleaseAmount(body).subscribe
                ((res) => {
                    this.loadingService.hide();
                    if (res.success == true) {
                        this.finishGood(res.message);
                        this.lcReleaseAmountId = res.result.lcReleaseAmountId;
                        this.getLcIssuances();
                    } else {
                        this.finishBad(JSON.stringify(res.message));
                    }
                }, (err: HttpErrorResponse) => {
                    this.loadingService.hide();
                    this.finishBad(JSON.stringify(err));
                });
        } else {
            this.lcService.UpdateReleaseAmount(body).subscribe
                ((res) => {
                    this.loadingService.hide();
                    if (res.success == true) {
                        this.finishGood(res.message);
                        this.lcReleaseAmountId = res.result.lcReleaseAmountId;
                        this.getLcIssuances();
                    } else {
                        this.finishBad(JSON.stringify(res.message));
                    }
                }, (err: HttpErrorResponse) => {
                    this.loadingService.hide();
                    this.finishBad(JSON.stringify(err));
                });
        }
    }

    setReleaseAmount() {
        this.releaseAmount = this.lcIssuanceForm.controls['releaseAmount'].value;
    }

    setoutstandingUsanceAmount(event) {
        let usAmt = this.lcUssanceForm.get('ussanceAmount').value;
        usAmt = parseFloat(String(usAmt).replace(/,/g,''));
        this.outstandingUsanceAmount = this.totalUsanceAmount - usAmt;
        // this.lcAmtExchangeRate = this.lcIssuanceForm.controls['lcAmtExchangeRate'].value;
        // this.nairaEquivalent = this.lcAmtExchangeRate * parseFloat(String(lcAmt).replace(/,/g,''));
        // this.lcIssuanceForm.controls['nairaEquivalent'].setValue(this.nairaEquivalent);
    }

  // ---------------------- message ----------------------

  show: boolean = false; message: any; title: any; cssClass: any;

  finishGood(message) { 
    this.showMessage(message, 'success', "FintrakBanking");
    this.loadingService.hide(); }

  hideMessage(event) { this.show = false; }

  finishBad(message) {
      this.showMessage(message, 'error', "FintrakBanking");
      this.loadingService.hide();
  }

  showMessage(message: string, cssClass: string, title: string) {
      this.message = message;
      this.title = title;
      this.cssClass = cssClass;
      this.show = true;
  }
}
